import InviteFriends from '@/components/basic/invite_friends'
import PaymentConfirm from '@/components/basic/payment_confirm'

const defaultModal = {
	adaptive: true,
	reset: true,
	resizable: true,
	draggable: false,
	styles: 'background-color: transparent;' // 移除白色背景
}

// 當在 modal component 呼叫 store action 來關閉時，務必在 component 引入 store.dispatch 來使用。

export default {
	actions: {
		openInviteFriendsModal ({ commit }, payload) {
			this._vm.$modal.show(InviteFriends, payload, Object.assign(defaultModal, {
				name: 'InviteFriendsModal', height: '70%', styles: 'background-color: transparent;box-shadow: none;'
			}))
		},
		closeInviteFriendsModal ({ commit }) {
			this._vm.$modal.hide('InviteFriendsModal')
		},
		openPaymentConfirmModal ({ commit }, payload) {
			this._vm.$modal.show(PaymentConfirm, payload, Object.assign(defaultModal, {
				name: 'PaymentConfirmModal', shiftY: 1, height: '80%', styles: 'background-color: transparent;box-shadow: none;'
			}))
		},
		closePaymentConfirmModal ({ commit }) {
			this._vm.$modal.hide('PaymentConfirmModal')
		}
	}
}
